import * as http from '@/utils/http.js'
import { setLocalStorage, getLocalStorage } from '@/utils/storage'

/**
 * 用户信息状态
 */

const USER_DATA = 'ww-user-info'

const DEFAULT_USER_INFO = {
  isLogin: false
}

const state = {
  userInfo: getLocalStorage(USER_DATA) || DEFAULT_USER_INFO
}

const mutations = {
  setUserInfo (state, info) {
    state.userInfo = {...info, isLogin: true}

    setLocalStorage(USER_DATA, state.userInfo)
  },

  resetUserInfo (state) {
    state.userInfo = { ...DEFAULT_USER_INFO }
  }
}

const actions = {
  async getUserPhone ({ commit }, code) {
    const { data } = await http.get('/user/h5/wx/work/getUserDetailByCode', {
      code
    })

    commit('setUserInfo', data)
  },
  async getUserInfo ({ commit }, info) {
    // 未获取到手机号
    if (!info.mobile) {
      commit('setUserInfo', {})
      return false
    }
    const { data } = await http.get('/user/h5/user/getPlatUserByPhone', {
      phone: info.mobile
    })

    const userInfo = data.data || {}
    commit('setUserInfo', {mobile: info.mobile, ...userInfo})
  }
}

const getters = {
  isLogin: (state) => {
    return !!state.userInfo.isLogin
  },
  userInfo: (state) => {
    return state.userInfo
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js